import { Directive } from '@angular/core';

declare var $: any;

@Directive({
    selector : '[updateScrollBar]',
  })

  export class UpdateScrollBarDirective {


    constructor(){}
    
    ngOnInit(){
        $(".content").mCustomScrollbar('update');
    }

    ngOnDestroy(){
       
    }
  
  }